import { ExclamationMarkTriangleFilled } from "components/icons/generated";
import Icon from "ds/components/Icon";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Tooltip from "ds/components/Tooltip";
import { VcsIntegration } from "types/generated";
import {
  getVCSIntegrationIssue,
  VCS_INTEGRATION_ISSUE_MESSAGE,
  VCSIntegrationIssue,
} from "views/Account/Integrations/registry/shared/VcsShared/components/IntegrationFeedback/helpers";

const VCSIntegrationsTableIssuesCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<VcsIntegration>) => {
  const issue = getVCSIntegrationIssue(integration);

  return (
    <TableSimpleCell {...cellProps}>
      {issue ? (
        <Tooltip
          mode="parent"
          on={(tooltipProps) => (
            <Icon
              {...tooltipProps}
              src={ExclamationMarkTriangleFilled}
              color={issue === VCSIntegrationIssue.APP_NOT_INSTALLED ? "warning" : "danger"}
              noShrink
            />
          )}
        >
          {VCS_INTEGRATION_ISSUE_MESSAGE[issue]}
        </Tooltip>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default VCSIntegrationsTableIssuesCell;
